Vue.component("service-provider-update-form", {
    mixins: [require("../../mixins/address")],
    props: {
        serviceProvider: {},
        serviceProviderTypes: {}
    },
    data () {
        return {
            address: this.serviceProvider.address,
            form: new AppForm({
                notes: this.serviceProvider.notes,
                name: this.serviceProvider.name,
                email: this.serviceProvider.email,
                phone: this.serviceProvider.phone,
                website: this.serviceProvider.website,
                vat_number: this.serviceProvider.vat_number,
                type: this.serviceProvider.type
            })
        };
    },
    computed: {
        addressLabel () {
            return !_.isEmpty(this.address.full_address) ? this.address.full_address : "No address";
        }
    },
    methods: {
        addressUpdated (address) {
            this.address = address;
        },
        saveServiceProvider () {
            App.patch("/serviceproviders/" + this.serviceProvider.id + "/update", this.form)
            .then((response) => {
                Bus.$emit("service-provider-updated", response);
                window.toastr.success("Updates Saved!");
            }).catch(() => {
                toastr.error("Could not update service provider");
            });
        }
    },
    created () {
        let self = this;
        Bus.$on("address-updated", function (address) {
            self.address = address;
            toastr.success("Address updated!");
        });
    }
});
